import React, { Component } from 'react';
import { Container } from 'reactstrap';

import { NavMenu } from './NavMenu';

export class Layout extends Component {
    render() {
        return (
            <div>
                <NavMenu hide={this.props.hide || (this.props.hideMenu && !this.props.diags)} />
                <Container>
                    {this.props.children}
                </Container>
            </div>
        );
    }
}
